/**
 * Recalculates the cart's delivery window in the visitor's browser: data-min / data-max business
 * days (Mon–Fri) from today, formatted in the page language. Updates [data-start] and [data-end].
 */
function addBusinessDays(from, days) {
  const date = new Date(from);
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) added += 1;
  }
  return date;
}

class EbDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min);
    const max = Number(this.dataset.max);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return;
    const today = new Date();
    // US notation (month before day) for every market, e.g. "Oct 21"
    const format = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const start = this.querySelector('[data-start]');
    const end = this.querySelector('[data-end]');
    if (start) start.textContent = format.format(addBusinessDays(today, min));
    if (end) end.textContent = format.format(addBusinessDays(today, Math.max(min, max)));
  }
}

if (!customElements.get('eb-delivery-estimate')) customElements.define('eb-delivery-estimate', EbDeliveryEstimate);
